import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "block font-semibold mb-1 text-red-900" }
const _hoisted_2 = { class: "list-disc list-inside" }
const _hoisted_3 = {
  key: 1,
  class: "block text-sky-800"
}

import { VNode } from 'vue';
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'GraphValidationErrors',
  props: {
    formatted_validation_errors: {}
  },
  setup(__props: any) {


    const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-hidden rounded-lg border hover:shadow-sm transition ease-in-out mt-4 mb-2 py-2 px-4", {
            'bg-red-50 border-red-900/20 hover:border-red-900/30': props.formatted_validation_errors.length > 0,
            'bg-sky-100/10 border-sky-900/20 hover:border-sky-900/30': !(props.formatted_validation_errors.length > 0),
        }])
  }, [
    (props.formatted_validation_errors.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_1, "There are " + _toDisplayString(props.formatted_validation_errors.length) + " errors in your graph", 1),
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.formatted_validation_errors, (validation_error, vei) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "validation-error text-red-800",
                key: vei
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validation_error, (err_part) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: err_part }, [
                    ((err_part as any).__v_isVNode ?? false)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(err_part), { key: 0 }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(err_part), 1)
                        ], 64))
                  ], 64))
                }), 128))
              ]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, "Graph contains no errors"))
  ], 2))
}
}

})